import React from 'react'

import RichTextComponent from '../../../sharedLegacy/components/RichTextComponent/RichTextComponent'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'

import './ThankYouMessageComponent.scss'

const ThankYouMessageComponent = () => {
  const { data: liveData } = useLiveDataQuery()

  if (!liveData || !!liveData.after_webinar_link) {
    return null
  }

  return (
    <div className="thank-you-message-component">
      <h3>{liveData.after_webinar_headline}</h3>
      <RichTextComponent text={liveData.after_webinar_message} />
    </div>
  )
}

export { ThankYouMessageComponent }
